
import { createSelector } from 'reselect'
// import { List } from 'immutable'

const projectCodeSelector = state => state.get('projectCode')

export const getIsFetching = createSelector(
  projectCodeSelector,
  projectCodeImmutable => {
    const projectCode = projectCodeImmutable.toJS()
    return projectCode.projectNonServiceGet.isFetching
    || projectCode.projectNonServiceEdit.isFetching
  }
)

export const getProjectNonService = createSelector(
  projectCodeSelector,
  projectCodeImmutable => {
    const projectCode = projectCodeImmutable.toJS()
    return projectCode.projectNonServiceGet.project
  }
)

export const getUpdatedProjectNonService = createSelector(
  projectCodeSelector,
  projectCodeImmutable => {
    const projectCode = projectCodeImmutable.toJS()
    return projectCode.projectNonServiceEdit
  }
)

export const getKeywordSearch = createSelector(
  projectCodeSelector,
  projectCodeImmutable => {
    const projectCode = projectCodeImmutable.toJS()
    return projectCode.projectCode.keywordSearch
  }
)



// WEBPACK FOOTER //
// ./src/selectors/project-code/project-code-selector.js